// extracted by mini-css-extract-plugin
export default {"link":"HeaderLinks_link__Yk2s7","auxTag":"HeaderLinks_auxTag__mWHul"};